import clsx from 'clsx';

export function Container({ className, ...props }) {
  return <div className={clsx('mx-3 sm:mx-8 lg:mx-[126px]', className)} {...props} />;
}
